export const GOOGLE_SIGN_IN_SCOPES = [
  'openid',
  'https://www.googleapis.com/auth/userinfo.email',
  'https://www.googleapis.com/auth/userinfo.profile',
] as const;

export const FACEBOOK_LOGIN_PERMISSIONS = ['public_profile', 'email'] as const;
